module.exports = __webpack_public_path__ + "img/cart-icon-audio-select.07992a96.svg";